module.exports = __webpack_public_path__ + "assets/devices/PM-102-PG2-feed7f4854be4b5727e0d53b87f1aea6.svg";